module.exports = __webpack_public_path__ + "static/img/unMute_camera2.14dd390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/unMute_camera2.png
// module id = Shui
// module chunks = 24